export var isQueryExecuted = function (queryResult) {
    return (queryResult &&
        !queryResult.isLoading &&
        (queryResult.isError || queryResult.isSuccess));
};
//# sourceMappingURL=utils.js.map